import React, { useState, useMemo } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import moment from 'moment';
import OpinionBarAndLineChart from '@intelligence/v3/components/OpinionBarAndLineChart';

const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = 'line',
    imageType = 'mobile',
    lineData,
    dateType,
    baseReleaseTime,
    earliestPeriod,
    secondTitleRight,
    lineSourceIcon,
    trendLoading,
    enableOpinionEventAnnotation = false,
    controlledEventAnnotation,
  } = props;

  const [chartLoading, setChartLoading] = useState(false);
  const [earliestClickValue, setEarliestClickValue] = useState<any>('');

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const linexAxis = list?.sort((a: any, b: any) => moment(a.date) - moment(b.date));
    let arr: any = [];
    for (const i in linexAxis) {
      arr.push({
        metric: '',
        source: 'appannie',
        time: showTimeByDateType(linexAxis[i].date, dateType?.toLocaleLowerCase()),
        value: linexAxis[i].value,
      });
    }

    if (earliestClickValue != '') {
      for (const n in arr) {
        if (arr[n]) {
          if (arr[n].time == earliestClickValue) {
            arr = arr.slice(n);
          }
        }
      }
    }

    return arr;
  };

  const onChartEarliestClick = (data: any) => {
    setEarliestClickValue(data.value);
  };

  const lineSeriesData = useMemo(() => {
    const arrGameData: any = [];

    for (const n in lineData) {
      const objTemp = {
        cover: lineData[n].name,
        id: lineData[n].name,
        name: lineData[n].name,
        history: getRpdTypeData(lineData[n].history || []),
      };
      arrGameData.push(objTemp);
    }

    return {
      source: arrGameData,
    };
  }, [lineData, earliestClickValue]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric: 'source',
    topChartsType: 'stats-retentionmonthly-trend',
    imageType,
    dateType,
    baseReleaseTime: showTimeByDateType(baseReleaseTime, dateType?.toLocaleLowerCase()),
    earliestPeriod: showTimeByDateType(earliestPeriod, dateType?.toLocaleLowerCase()),
    secondTitleRight,
    lineSourceIcon,
  });

  return (
    <>
      <div className="card-line">
        {enableOpinionEventAnnotation ? (
          <OpinionBarAndLineChart
            chartLoading={trendLoading || chartLoading}
            lineOption={lineOption}
            chartType={chartType}
            chartHeight={350}
            onChartEarliestClick={onChartEarliestClick}
            enableEventAnnotation
            controlledEventAnnotation={controlledEventAnnotation}
            opinionEventConfig={{
              gameIds: [],
              startTime: '',
              endTime: '',
              dateType,
            }}
          />
        ) : (
          <ChartsIndex
            chartLoading={chartLoading}
            lineOption={lineOption}
            chartType={chartType}
            onChartEarliestClick={onChartEarliestClick}
          />
        )}
      </div>
    </>
  );
};

export default Visualis;
